const { useState, useEffect }  =  wp.element;
const { extensionCartUpdate } = wc.blocksCheckout;
import metadata from './block.json';
//import '../../../../css/main.css';
const { getSetting } = wc.wcSettings;

const WPSlashTippingBlockFront = ( { cart , className} ) => {


    const tippingSettings = getSetting( 'wc-tipping-blocks_data' );

	const onChangeTipAmount = ( newTip ) => {


		setCurrentTip(parseInt(newTip));
	};
	
	const tipFromCart = cart ? cart.cartFees.find(o=>o.key === "tip"): null;
	const [currentTip, setCurrentTip] = tipFromCart ? useState(tipFromCart.totals.total/100)  : useState(tippingSettings.default_tip_amount)
	const [loading, setLoading] = useState(false)


	const onAddTip = ( newTip ) => {
		setLoading(true);
		wc.blocksCheckout.extensionCartUpdate( {
			namespace: 'wpslash-tipping-for-woocommerce',
			data: {
				amount: currentTip
			},
		} ).then((response)=>
		{
			setLoading(false);
			setCurrentTip(response.fees.find(o=>o.key === "tip").totals.total/100)

			console.log(response);

		});

	};

		const onRemoveTip = (  ) => {
		setLoading(true);
		wc.blocksCheckout.extensionCartUpdate( {
			namespace: 'wpslash-tipping-for-woocommerce',
			data: {
				remove_tip: true
			},
		} ).then((response)=>
		{
			setLoading(false);
			setCurrentTip(response.fees.find(o=>o.key === "tip").totals.total/100)

			console.log(response);

		});

	};


	const onAddPercentageTip = ( percentage ) => {
		setLoading(true);

		wc.blocksCheckout.extensionCartUpdate( {
			namespace: 'wpslash-tipping-for-woocommerce',
			data: {
				percentage:percentage
			},
		} ).then((response)=>
		{

			console.log(response);
			setCurrentTip(response.fees.find(o=>o.key === "tip").totals.total/100)
			setLoading(false);

		});

	};



	return (
		<div className={className} >

		<div className="wpslash-tip-wrapper " style={{
			background: tippingSettings.body_background_color || undefined
		}}>

		<div className="wpslash-tip-title" style={{
			background: tippingSettings.title_background_color || undefined,
			color: tippingSettings.title_text_color || undefined,

		}}>
		{tippingSettings.title}			
		</div>	


		{(() => {
			
				return (
					<div className="wpslash-tipping-form-wrapper">

					<input type="number" value={currentTip} className="wpslash-tip-input" onInput={e => onChangeTipAmount(e.target.value)}/>
					<a className={loading ? "wpslash-tip-submit button loading" :  "wpslash-tip-submit button"} onClick={(e) => {e.preventDefault(), onAddTip(e) }} style={cart  && cart.cartFees.some(item => item.key === 'tip') ? {display:'None'} : {
						background: tippingSettings.buttons_background_color,
						color: tippingSettings.buttons_text_color,
						borderColor: tippingSettings.buttons_background_color,

					}} 
					>Add</a>

					<a className={loading ? "wpslash-tip-submit button loading" :  "wpslash-tip-submit button"} onClick={(e) => {e.preventDefault(), onRemoveTip(e) }}   style={cart && cart.cartFees.some(item => item.key === 'tip') ? {
							background: tippingSettings.buttons_background_color,
						color: tippingSettings.buttons_text_color,
						borderColor: tippingSettings.buttons_background_color,

					} : {display:'None'}} 
					>Remove</a>
					</div>
					)
			

		})()}


		<div className="wpslash-percentage-tip-buttons">

		{tippingSettings.tip_percentages.map(function(percentage, i){
			return (
				<a key={i} 

				onClick={(e) => {e.preventDefault(), onAddPercentageTip(percentage) }}
				className={loading ? "wpslash-tip-percentage-btn button loading" :  "wpslash-tip-percentage-btn button"} 
				percentage={percentage} 
				style={{
						background: tippingSettings.buttons_background_color,
						color: tippingSettings.buttons_text_color,
						borderColor: tippingSettings.buttons_background_color,

				}}>{percentage}%</a>


				);

		})}


		</div>
				


		</div>
		

		
		</div>
		);



}
export default WPSlashTippingBlockFront;

